export default {

  getScaleData: {
    path: '/interact/resource/{resource_id}',
    restful: true
  },
  postScaleResult: {
    path: "/interact/{classroom_id}/scale/{exam_id}/record",
    restful: true,
    method: 'post'
  },
  deleteScale:{
    path:"p/{pid}/scale/{resource_id}",
    restful: true,
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/modules/lesson-scale/apis.js